import { useQuery } from '@apollo/client';
import { CURRENT_CLIENT } from '@src/graphql/queries/client';
export const useCurrentClient = () => {
    const { data, loading, error } = useQuery(CURRENT_CLIENT);
    const currentClient = data?.currentClient;
    return {
        currentClient,
        loading,
        error,
    };
};
